import { myFetch } from "./fetch-config";

const url = "https://mainnet.bityuan.com/btydata/bityuan";
// const url = "/bityuan";
const kline = "https://www.zhaobi.xyz/kline";
const dns = "/dns";

// 获取BTY K线数据
export function getKdata(format = "D1", range = "7") {
    let url =
        kline +
        `/kdata?c=BTYUSDT&p=${format}&action=init&count=${range}&callback=jQuery112406248373254640218_1472016715089`;
    return myFetch(null, url, {
        method: "GET",
    });
}

// 获取BTY实时价格
export function getBTYPrice() {
    const url = "/ticker/v2/ticker?symbol=BTY-USDT";
    return myFetch(null, url, { method: "GET" });
}

// 获取LBANK价格
export function getLBPrice() {
    const url = "/ticker/v2/supplement/ticker/price.do?symbol=bty_usdt";
    return myFetch(null, url, { method: "GET" });
}

// LBANK价格新接口
export function getLBPriceNew() {
    const url = "/tapi/ticker";
    return myFetch(null, url, { method: "GET" });
}

// 交易列表
export function txList(params) {
    let body = {
        id: 1,
        method: "Tx.TxList",
        params: params,
    };
    return myFetch(body, url);
}

// token交易列表
export function tokenTxList(params) {
    let body = {
        id: 1,
        method: "Token.TxList",
        params: params,
    };
    return myFetch(body, url);
}

// 代币持有人
export function tokenHolder(params) {
    let body = {
        method: "Token.TokenAddrCount",
        params: params,
    };
    return myFetch(body, url);
}

// 代币个人持有人列表
export function tokenHolderList(params) {
    let body = {
        method: "Token.AddrsInfo",
        params: params,
    };
    return myFetch(body, url);
}

// 代币个人、合约持有人列表
export function conbineHolderList(params) {
    let body = {
        method: "Account.Search",
        params: params,
    };
    return myFetch(body, url);
}

// 主代币持有人总数
export function mainCoinsHolders(params) {
    let body = {
        id: 1,
        method: "Account.Count",
        params: params,
    };
    return myFetch(body, url);
}

// 交易总条数
export function getTxCount(params) {
    let body = {
        id: 1,
        method: "Tx.TxCount",
        params: params,
    };
    return myFetch(body, url);
}

// 获取区块区间信息
export function getBlocksInfo(params) {
    let body = {
        id: 1,
        method: "BlockStat.StatGets",
        params: params,
    };
    return myFetch(body, url);
}

// search区块统计信息
export function searchBlocksInfo(params) {
    let body = {
        id: 1,
        method: "BlockStat.StatSearches",
        params: [params],
    };
    return myFetch(body, url);
}

// 比特元持币排行
export function btyHolderRank(params) {
    let body = {
        id: 1,
        method: "Account.TopAsset",
        params: params,
    };
    return myFetch(body, url);
}

// 比特元持币人数总量
export function btyHolderNum() {
    let body = {
        method: "Account.TopAssetCount",
        params: [{}],
        id: 1,
    };
    return myFetch(body, url);
}

/**
 * DNS查询
 *
 * @export
 * @param {*} adr DNS、地址
 * @param {*} type 0-域名查地址，1-地址查域名
 * @return {*}
 */
export function SearchDNS(adr, type = 0) {
    let url = dns + `/resolve?key=${adr}&kind=${type}`;
    return myFetch(null, url, {
        method: "GET",
    });
}

/**
 * evm交易信息补充
 *
 * @export
 * @param {*} hash
 */
export function txEvm(hash) {
    const body = {
        method: "Evm.ParseTx",
        params: [
            {
                tx_hash: hash,
            },
        ],
    };
    return myFetch(body, url);
}
